var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSitemap = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 12C22.5 11.1716 21.8284 10.5 21 10.5H12.75V7.5H11.25V10.5H3C2.17157 10.5 1.5 11.1716 1.5 12V16.5H3V12.3C3 12.1343 3.13431 12 3.3 12H11.25V16.5H12.75V12H20.7C20.8657 12 21 12.1343 21 12.3V16.5H22.5V12Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 17.25C4.5 16.8358 4.16421 16.5 3.75 16.5H0.75C0.335786 16.5 0 16.8358 0 17.25V20.25C0 20.6642 0.335787 21 0.75 21H3.75C4.16421 21 4.5 20.6642 4.5 20.25V17.25ZM3 18H1.5V19.5H3V18Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 17.25C24 16.8358 23.6642 16.5 23.25 16.5H20.25C19.8358 16.5 19.5 16.8358 19.5 17.25V20.25C19.5 20.6642 19.8358 21 20.25 21H23.25C23.6642 21 24 20.6642 24 20.25V17.25ZM22.5 18H21V19.5H22.5V18Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.25 17.25C14.25 16.8358 13.9142 16.5 13.5 16.5H10.5C10.0858 16.5 9.75 16.8358 9.75 17.25V20.25C9.75 20.6642 10.0858 21 10.5 21H13.5C13.9142 21 14.25 20.6642 14.25 20.25V17.25ZM12.75 18H11.25V19.5H12.75V18Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.25 3.75C14.25 3.33579 13.9142 3 13.5 3H10.5C10.0858 3 9.75 3.33579 9.75 3.75V6.75C9.75 7.16421 10.0858 7.5 10.5 7.5H13.5C13.9142 7.5 14.25 7.16421 14.25 6.75V3.75ZM12.75 4.5H11.25V6H12.75V4.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSitemap);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sitemap.49a8962832e5bce83b5c60bd98583bc8.svg";